<template>
    <div style="width: 300px; color: #fff; border-radius: 4px;" class="px-2 py-4" >
        <div class="font-weight-bold text-body-1 mb-3" style="color: #fff">
            {{  $t('healthcoin-description.header') }}
        </div>
        <div class="text-body-2 mb-3" style="color: #fff">
            {{  $t('healthcoin-description.desc[0]') }}
        </div>
        <div class="text-body-2" style="color: #fff">
            {{  $t('healthcoin-description.desc[1]') }}
        </div>
    </div>
</template>

<script setup>
    import _ from 'lodash'
    const props = defineProps(['breadcrumbs'])

    const breadcrumb = ref([])
    await onMounted(() => onLoad())
    async function onLoad() {
        const home = {
            title: 'mainmenu.home',
            disabled: false,
            to: '/'
        }
        breadcrumb.value = _.chain(home).concat(props.breadcrumbs).compact().value()
    }
</script>